/* eslint-disable */
require('./about')
require('./add')
require('./addCircle')
require('./addPer')
require('./addreport')
require('./address')
require('./allProject')
require('./authorize')
require('./camera')
require('./check')
require('./circle')
require('./close')
require('./contractMsg')
require('./copy')
require('./crossbarCircle')
require('./dui')
require('./edit')
require('./equipmentLedger')
require('./error')
require('./errorCircle')
require('./expandIcon')
require('./fault')
require('./feedback')
require('./fileDoc')
require('./fileExl')
require('./filePdf')
require('./good')
require('./hourglass')
require('./icon_close')
require('./icon_delate')
require('./icon_mima')
require('./icon_shoujihao')
require('./icon-photo')
require('./iconCilp')
require('./iconEdit')
require('./iconOnlineTest')
require('./iconPhone')
require('./InsurancePolicy')
require('./jiedian')
require('./leftArrow')
require('./logo')
require('./maintain')
require('./myTeam')
require('./newMember')
require('./nextOne')
require('./noData')
require('./notAdd')
require('./note')
require('./organization')
require('./password')
require('./plan')
require('./safeEducation')
require('./search')
require('./seeMore')
require('./setting')
require('./sh-logo')
require('./shenhualogo')
require('./signal')
require('./star')
require('./starBlack')
require('./starWhite')
require('./technicalDisclosure')
require('./tipArrow')
require('./trophy')
require('./userMsg')
require('./userName')
require('./verify')
require('./vue')
require('./yesCircle')
require('./yesIcon')
require('./zhiding')



// WEBPACK FOOTER //
// ./src/views/icons/index.js